import { Controller } from "react-hook-form";
import { useEffect } from "react";
import { InputText } from "primereact/inputtext";

import { useAppDispatch, useAppSelector } from "store/store";
import { EmailInputProps } from "../../../interfaces";
import { emailRegex, noEmojiRegex } from "utils";
import {
  setDomainValidation,
  setEmailValidation,
} from "store/slicer/registerFormSlice";
import { setIsEmailExists } from "store/slicer/resetPasswordFormSlice";
import {
  erroreCampoObbligatorio,
  erroreCaratteriNonValidi,
  erroreFormatoEmail,
  inputEmail,
  errorDomaniNotValid,
  errorEmailAlreadyUsed,
  errorEmailNotExist,
  errorEmailAlreadyRegistered,
} from "../../../_constants";
import { setLoginFormValid } from "store/slicer/FormLoginValidationSlice";
import { setAddUserEmailValidation } from "store/slicer/FormAddUserValidationSlice";

export const EmailInput = ({
  control,
  placeholder,
  isLogin = false,
  trigger,
  disabled = false,
}: EmailInputProps) => {
  const dispatch = useAppDispatch();
  const isEmailValid = useAppSelector(
    (state) => state.registerFormSlice.validEmail
  );
  const isDomainValid = useAppSelector(
    (state) => state.registerFormSlice.validDomain
  );
  const isEmailExists = useAppSelector(
    (state) => state.resetPasswordFormSlice.IsEmailExists
  );
  const isLoginFormValid = useAppSelector(
    (state) => state.formLoginValidationSlice.loginFormIsValid
  );
  const isAddUserEmailFormValid = useAppSelector(
    (state) => state.formAddUserValidationSlice.addUserEmailIsValid
  );

  const resetRegisterValidationStatus = () => {
    dispatch(setEmailValidation(true));
    dispatch(setDomainValidation(true));
    dispatch(setIsEmailExists(false));
    dispatch(setLoginFormValid(true));
    dispatch(setAddUserEmailValidation(true));
  };
  useEffect(() => {
    if (trigger && control._getDirty()) {
      trigger("email");
    }
  }, [
    isEmailExists,
    isEmailValid,
    isDomainValid,
    isLoginFormValid,
    isAddUserEmailFormValid,
    trigger,
    control,
  ]);
  return (
    <Controller
      name="email"
      control={control}
      rules={
        isLogin
          ? {
              required: erroreCampoObbligatorio,
              validate: {
                emailCheck: () => {
                  return isLoginFormValid;
                },
              },
            }
          : {
              required: erroreCampoObbligatorio,
              validate: {
                emailFormat: (value) =>
                  emailRegex.test(value) || erroreFormatoEmail,
                noEmoji: (value) =>
                  !noEmojiRegex.test(value) || erroreCaratteriNonValidi,
                emailCheck: () => {
                  if (isLogin) return true;
                  if (!isEmailValid) return errorEmailAlreadyUsed;
                  if (!isDomainValid) return errorDomaniNotValid;
                  if (isEmailExists) return errorEmailNotExist;
                  if (!isAddUserEmailFormValid)
                    return errorEmailAlreadyRegistered;

                  return true;
                },
              },
            }
      }
      render={({ field, fieldState: { error, isTouched } }) => (
        <div className="flex-container column">
          <InputText
            id={field.name}
            {...field}
            disabled={disabled}
            className={
              isLogin
                ? !isLoginFormValid
                  ? "p-invalid "
                  : ""
                : (error ||
                    !isEmailValid ||
                    !isDomainValid ||
                    isEmailExists ||
                    !isAddUserEmailFormValid) &&
                  isTouched
                ? "p-invalid margin-bottom-4"
                : ""
            }
            placeholder={placeholder ? placeholder : inputEmail}
            onFocus={resetRegisterValidationStatus}
          />
          <small className="p-error">
            {!isLogin && isTouched ? error?.message : ""}
          </small>
        </div>
      )}
    />
  );
};
